module.exports = __webpack_public_path__ + "img/shop-ad-03.846c7653.png";